import {
  type EnvironmentProviders,
  makeEnvironmentProviders,
} from '@angular/core'
import * as ngrxEffects from '@ngrx/effects'
import * as ngrxStore from '@ngrx/store'
import * as ngrxStoreDevtools from '@ngrx/store-devtools'

import { META_EFFECT } from './effects'
import { META_REDUCER } from './reducers'

/** Provides everything needed for this library */
export function provideStore({
  enableDevtools = false,
}: provideStore.Options = {}): EnvironmentProviders {
  return makeEnvironmentProviders([
    ngrxStore.provideStore({}, { metaReducers: [META_REDUCER] }),
    ngrxEffects.provideEffects([{ meta: META_EFFECT }]),
    // NOTE: this must appear AFTER the store is provided, otherwise it won't
    // work
    ...(enableDevtools
      ? [
          ngrxStoreDevtools.provideStoreDevtools({
            logOnly: true,
            // Retain last 500 states to prevent Redux DevTools from crashing
            maxAge: 500,
            name: 'Attain Apps',
            serialize: { options: { map: true, set: true } },
          }),
        ]
      : []),
  ])
}
export namespace provideStore {
  export interface Options {
    /**
     * Enables {@link https://ngrx.io/guide/store-devtools Devtools}
     */
    enableDevtools?: boolean
  }
}
